module.exports = __webpack_public_path__ + "img/thumbnail_Ocelot_j_normal.19ecdc47.png";